<template>
  <div>
    <div class="head-box">
      <h4>质保库审核</h4>
      <div class="c-flex c-flex-item">
        <!-- <el-input
          placeholder="请输入名称/描述"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input> -->
        <el-button
          type="primary"
          @click="doNew"
          class="c-m-l-10"
          v-if="osg.has('WarrantyItemAudit,new')"
        >
          新增质保库
        </el-button>
        <el-dropdown class="c-m-l-10" @command="audit" v-if="osg.has('WarrantyItemAudit,audit')">
          <el-button type="primary">
            审核
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">审核通过</el-dropdown-item>
            <el-dropdown-item command="2">审核不通过</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          @selection-change="selectRows"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column type="selection" width="55" fixed></el-table-column>
          <c-table :fields="extFields"></c-table>
          <el-table-column
            fixed="right"
            width="110"
            label="操作"
            v-if="
              osg.has('WarrantyItemAudit,edit') ||
                osg.has('WarrantyItemAudit,enable') ||
                osg.has('WarrantyItemAudit,remove')
            "
          >
            <template slot-scope="scope">
              <el-dropdown class="c-m-l-10">
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="osg.has('WarrantyItemAudit,edit')"
                    @click.native="doEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>
                  <template v-if="osg.has('WarrantyItemAudit,enable')">
                    <el-dropdown-item
                      v-if="scope.row.state == 1"
                      @click.native="doDisable(scope.row._id)"
                    >
                      禁用
                    </el-dropdown-item>
                    <el-dropdown-item v-else @click.native="doEnable(scope.row._id)">
                      启用
                    </el-dropdown-item>
                  </template>
                  <el-dropdown-item
                    v-if="osg.has('WarrantyItemAudit,remove')"
                    @click.native="doRemove(scope.row._id)"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="质保库" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        labelWidth="110px"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave()">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'WarrantyItem',
  data() {
    window.$this = this;
    return {
      type: '',
      tenantId: '',
      loginOrgId: '',
      name: 'warrantyItem',
      fpi: {},
      selectedRows: [],
      searchValue: '',
      openDetail: false,
      formData: { materialIds: [], procedureIds: [] },
      extFields: [],
      extField: {},
      rules: this.$util.rules,
      options: {},
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 10
      }
    };
  },
  mounted() {
    let account = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = account.tenantId;
    this.loginOrgId = account.orgId;

    this.doInit();
    this.osg.getFields('warrantyItem', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.formData = { materialIds: [], procedureIds: [] };
      this.openDetail = false;
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#or': this.searchValue,
        'regex:description|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        'exists:auditStatus|boolean#and': true,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/warrantyItem/query.do', params, res => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.$util.renderExtField(this.extFields, row);
      if (this.$util.isJson(row.image)) {
        row.image = JSON.parse(row.image);
      }
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      let params = this.$util.deepCopy(this.formData);
      params.auditStatus = 0; //修改数据时审核状态改为0

      // 超级管理员、平台管理员、当前组织都可以看到此条数据
      params.orgIds = params.orgIds || [];
      if (params.orgIds.indexOf('0') == -1) params.orgIds.push('0');
      if (params.orgIds.indexOf(this.tenantId) == -1) params.orgIds.push(this.tenantId);
      if (params.orgIds.indexOf(this.loginOrgId) == -1) params.orgIds.push(this.loginOrgId);

      this.$util.saveExtField(this.extFields, params);
      if (this.osg.validate()) {
        this.osg.ajax('basic/warrantyItem/upsert.do', { data: JSON.stringify(params) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax(`basic/warrantyItem/enable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('启用成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax(`basic/warrantyItem/disable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('禁用成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`basic/warrantyItem/remove/${id}.do`, null, () => {
          this.osg.toast('删除成功！');
          this.getData();
        });
      });
    },
    // 列表多选
    selectRows(rows) {
      this.selectedRows = rows;
    },
    // 审核
    audit(auditStatus) {
      /**
       * auditStatus
       * 0:待审核（新建后是自由态-->审核状态设为0:待审核）
       * 1:审核通过（平台点审核通过-->审核状态改为1:审核通过）
       * 2:审核不通过（平台点审核通过-->审核状态改为2:审核不通过）
       */
      // 至少选择一条数据
      if (this.selectedRows.length == 0) {
        this.osg.toast('请至少勾选一条待审核的数据', 'warning');
        return;
      }
      // 判断选择的审核状态是否符合审核条件
      let msg = '';
      let confirmMsg = '';
      switch (auditStatus) {
        case '1':
          for (let row of this.selectedRows) {
            if (row.auditStatus != '0') {
              this.osg.alert(`您选择的${row.name || '行'}，不是“待审核”状态！`);
              return;
            }
          }
          confirmMsg = '审核通过';
          msg = '审核通过，处理完成。';
          break;
        case '2':
          for (let row of this.selectedRows) {
            if (row.auditStatus != '0') {
              this.osg.alert(`您选择的${row.name || '行'}，不是“待审核”状态！`);
              return;
            }
          }
          confirmMsg = '审核不通过';
          msg = '审核不通过，处理完成。';
          break;
        default:
      }
      this.osg.confirm(`是否确认“${confirmMsg}”？`, () => {
        this.auditConfirm(auditStatus, msg);
      });
    },
    auditConfirm(auditStatus, msg) {
      this.osg.ajax(
        'basic/warrantyItem/auditStatus.do',
        {
          data: JSON.stringify({
            datas: this.selectedRows,
            newAuditStatus: auditStatus
          })
        },
        () => {
          this.osg.toast(msg);
          this.getData();
        }
      );
    }
  }
};
</script>
